import { memo } from 'react';
import { FormattedMessage } from 'react-intl';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { Button, DialogContent, Paper, Stack, Typography } from '@mui/material';

import Dialog from '@/components/dialogs/Dialog';

const classes = {
  card: {
    alignItems: 'center',
    border: 1,
    borderColor: 'grey.500',
    display: 'flex',
    flexDirection: 'column',
    height: 256,
    justifyContent: 'space-between',
    padding: 2,
    width: 216,
  },
};

interface Props {
  isOpen?: boolean;
  onConnectBankAccountClick: () => void;
  onDialogClose: () => void;
  onEnterBankAccountDetailsClick: () => void;
}

const VoidChequeEftDialog = ({
  isOpen,
  onConnectBankAccountClick,
  onDialogClose,
  onEnterBankAccountDetailsClick,
}: Props) => (
  <Dialog
    onDialogClose={onDialogClose}
    isOpen={isOpen}
    title={<FormattedMessage defaultMessage="Deposit your money" />}
  >
    <DialogContent>
      <Stack direction={{ xs: 'column', md: 'row' }} justifyContent="space-between" gap={3}>
        <Paper sx={classes.card} elevation={0}>
          <AccountBalanceIcon color="action" fontSize="large" />

          <Typography
            variant="body1"
            fontWeight="bold"
            align="center"
            id="void-cheque-dialog-banking-sign-in"
          >
            <FormattedMessage defaultMessage="Connect your Bank Account" />
          </Typography>

          <Typography
            variant="body2"
            align="center"
            id="void-cheque-dialog-banking-sign-in-description"
          >
            <FormattedMessage defaultMessage="Sign in with your banking credentials." />
          </Typography>

          <Button
            aria-describedby="void-cheque-dialog-banking-sign-in-description"
            aria-labelledby="void-cheque-dialog-banking-sign-in"
            color="primary"
            onClick={onConnectBankAccountClick}
          >
            <FormattedMessage defaultMessage="Connect" />
          </Button>
        </Paper>
        <Paper sx={classes.card} elevation={0}>
          <AssignmentIcon color="action" fontSize="large" />

          <Typography
            variant="body1"
            fontWeight="bold"
            align="center"
            id="void-cheque-dialog-connect-bank-account"
          >
            <FormattedMessage defaultMessage="Enter your Bank Account Details" />
          </Typography>

          <Typography
            variant="body2"
            align="center"
            id="void-cheque-dialog-connect-bank-account-description"
          >
            <FormattedMessage defaultMessage="Use your transit, institution and account numbers." />
          </Typography>

          <Button
            aria-describedby="void-cheque-dialog-connect-bank-account-description"
            aria-labelledby="void-cheque-dialog-connect-bank-account"
            color="primary"
            onClick={onEnterBankAccountDetailsClick}
          >
            <FormattedMessage defaultMessage="Connect" />
          </Button>
        </Paper>
      </Stack>
    </DialogContent>
  </Dialog>
);

export default memo(VoidChequeEftDialog);
